import get from 'lodash/get';

const styles = ({ color }) => ({
  additionalSaveBtn: {
    float: 'left',
    marginRight: 20,
  },
  additionalForceSaveBtn: {
    backgroundColor: get(color, 'error'),
    color: get(color, 'primaryButtonText'),
    float: 'left',
    marginRight: 20,
  },
  apiCategoryConfigsList: {
    alignItems: 'flex-start',
    display: 'flex',
    marginBottom: 16,
  },
  apiCategoryOrderConfigItem: {
    display: 'flex',
    marginRight: 10,
  },
  apiCategoryNonCompliantConfigItem: {
    display: 'flex',
  },
  apiComplianceBtnGroup: {
    marginBottom: 0,
    marginTop: 0,
  },
  apiRightBtnGroup: {
    display: 'inline-flex',
  },
  assistText: {
    marginLeft: 4,
  },
  assistTextIcon: {
    display: 'flex',
  },
  assistTextContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  categoriesMenuList: {
    maxHeight: 200,
    '@media (min-height: 480px)': {
      maxHeight: 300,
    },
    '@media (min-height: 720px)': {
      maxHeight: 360,
    },
  },
  categoryConfigsList: {
    display: 'flex',
    listStyleType: 'None',
    marginLeft: 8,
    paddingLeft: 0,
    '& li:not(:first-child)': {
      paddingLeft: 4,
    },
    '& li': {
      paddingLeft: 0,
      paddingRight: 0,
      '&:not(:last-child)::after': {
        color: get(color, 'bodyText'),
        content: '"  •"',
      },
    },
  },
  categoryHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  categoryHelpTextContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  categoryWiseError: {
    display: 'flex',
  },
  categoryWiseErrorContainer: {
    display: 'flex',
  },
  categorySubTitle: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  complianceError: {
    color: get(color, 'error'),
    fill: get(color, 'error'),
  },
  complianceErrorText: {
    color: get(color, 'error'),
    fill: get(color, 'error'),
    marginLeft: 4,
  },
  complianceInfoText: {
    marginLeft: 4,
  },
  complianceWarning: {
    color: get(color, 'warning'),
    fill: get(color, 'warning'),
  },
  complianceWarningText: {
    color: get(color, 'warning'),
    fill: get(color, 'warning'),
    marginLeft: 4,
  },
  expandTemplatesContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  footerNextBtn: {
    backgroundColor: `${get(color, 'primaryButtonText')} !important`,
    color: `${get(color, 'primaryButtonBackground')} !important`,
  },
  footerForceSaveBtn: {
    backgroundColor: `${get(color, 'error')} !important`,
    borderColor: `${get(color, 'error')} !important`,
    color: `${get(color, 'primaryButtonText')} !important`,
  },
  greyBand: {
    backgroundColor: `${get(color, 'lightGray')} !important`,
    height: 8,
    marginBottom: 84,
    marginLeft: -36,
    marginRight: -20,
  },
  nextBtnContent: {
    display: 'flex',
    alignItems: 'center',
  },
  nextBtnIcon: {
    display: 'flex',
    marginLeft: 8,
  },
  noCategoriesErrorContainer: {
    alignItems: 'center',
    color: get(color, 'error'),
    display: 'flex',
  },
  pageTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  templatesBtns: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  templateExpandBtn: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  popper: {
    zIndex: 1200,
  },
});

export default styles;
